module.exports = __webpack_public_path__ + "media/images/countrysquared/sd-2df0d878a488d63d04ba07af9f52f4db.svg";